'use client';

import { showCookiePreferences } from '@/lib/cookieConsent';

export default function CookieSettingsLink() {
  return (
    <button
      type="button"
      onClick={showCookiePreferences}
      style={{
        background: 'none',
        border: 'none',
        padding: 0,
        cursor: 'pointer',
        color: 'inherit',
        font: 'inherit',
      }}
    >
      Configuració de cookies
    </button>
  );
}
